const _filter = {
  areaid: 1,
  categoryid: 1,
  styleid: 1
}


export default (state = _filter, action) => {
  switch (action.type) {
    case 'SET_FILTER':
      const ret = {
        areaid: parseInt(action.filter.areaid || 1),
        categoryid: parseInt(action.filter.categoryid || 1),
        styleid: parseInt(action.filter.styleid || 1)
      }
      return ret
    default:
      return state
  }
}



// WEBPACK FOOTER //
// ./reducers/filter.js